import * as z from 'zod';
import { isoDateTimeToDayJs } from './base-codecs';
import { EntityId, Tag } from './base-schemas';
import { PositionModel } from './Position';
export const CategoryModel = z.object({
    _tag: Tag('CategoryModel'),
    id: EntityId,
    name: z.string(),
    created_at: isoDateTimeToDayJs.nullable(),
    updated_at: isoDateTimeToDayJs.nullable(),
    deleted_at: isoDateTimeToDayJs.nullable()
});
export const EnrichedCategory = CategoryModel.extend({
    _tag: Tag('EnrichedCategory'),
    isEnriched: z.literal(true),
    // get lodgingTypes() { return z.array(LodgingTypeModel) },
    // get cancellationPolicies() { return z.array(CancellationPolicyModel) },
    get positions() { return z.array(PositionModel).optional(); }
    // get defaultLodgingType() { return LodgingTypeModel.optional() },
});
